import axios from 'axios';
import { getApiClientFront, getApiClientBack } from "../api/api";


// const apiUrlMap = {
//   // "pruebabopiweb.oepm.es": "http://pruebaconsultas5.oepm.es:5000",
//   // "pruebabopiweb.oepm.es": "https://pruebabopiweb.oepm.es/apibopiweb",
//   "pruebasede.oepm.gob.es": "https://pruebasede.oepm.gob.es/bopi/apibopiweb",
//   "prebopiweb.oepm.es": "https://prebopiweb.oepm.es/apibopiweb",
//   "bopiweb.oepm.es": "https://bopiweb.oepm.es/apibopiweb",

//   "defaultApiUrl": "Error",
//   "localhost": "http://localhost:5000",    
// };

// const api = axios.create({
//   //  baseURL: "http://localhost:8080/BopiWeb/"    
//   baseURL: apiUrlMap[window.location.hostname] || apiUrlMap["defaultApiUrl"],
// })

export const getCapitulosTomo1 = async () => {
  const api = await getApiClientBack();
  const response = await api.get("/capitulosTomo1");
  return response.data;
};

export const getCapitulosTomo2 = async () => {
  const api = await getApiClientBack();
  const response = await api.get("/capitulosTomo2");
  return response.data;
};

export const getCapitulosTomo3 = async (leyId) => {
  const api = await getApiClientBack();
  const response = await api.get("/capitulosTomo3", {
    params: { leyId },
  });
  return response.data;
};

export const getLeyesTomo2 = async (capituloId) => {
  const api = await getApiClientBack();
  const response = await api.get("/leyesTomo2", {
    params: { capituloId },
  });
  return response.data;
};

export const getLeyesTomo3 = async () => {
  const api = await getApiClientBack();
  const response = await api.get("/leyesTomo3");
  return response.data;
};

export const getSubcapitulosByCapituloId = async (capituloId) => {
  const api = await getApiClientBack();
  const response = await api.get("/subcapitulos", {
    params: { capituloId },
  });
  return response.data;
};

export const getSubcapitulosByCapituloIdAndLey = async (capituloId, leyId) => {
  const api = await getApiClientBack();
  const response = await api.get("/subcapitulosByCapituloIdAndLey", {
    params: { capituloId, leyId },
  });
  return response.data;
};

export const getApartadosBySubcapituloId = async (subcapituloId) => {
  const api = await getApiClientBack();
  const response = await api.get("/apartadosBySubcapitulo", {
    params: { subcapituloId },
  });
  return response.data;
};

export const getSubapartadosByApartadoId = async (capituloId, subcapituloId, apartadoId) => {
  const api = await getApiClientBack();
  const response = await api.get("/subapartados", {
    params: { capituloId, subcapituloId, apartadoId },
  });
  return response.data;
};

export const getSubapartadosBySubcapituloId = async (subcapituloId) => {
  const api = await getApiClientBack();
  const response = await api.get("/subapartadosBySubcapituloId", {
    params: { subcapituloId },
  });
  return response.data;
};

export const getSubapartadosByCapituloId = async (capituloId) => {
  const api = await getApiClientBack();
  const response = await api.get("/subapartadosByCapituloId", {
    params: { capituloId },
  });
  return response.data;
};

export const getModalidadesTomo1 = async () => {
  const api = await getApiClientBack();
  const response = await api.get("/modalidadesTomo1");
  return response.data;
};

export const getModalidadesTomo2 = async () => {
  const api = await getApiClientBack();
  const response = await api.get("/modalidadesTomo2");
  return response.data;
};

export const getModalidadesTomo3 = async () => {
  const api = await getApiClientBack();
  const response = await api.get("/modalidadesTomo3");
  return response.data;
};